import { Head } from "@/components/base/Head";
import { Breadcrumb } from "@/components/base/Breadcrumb";
import React from "react";
import Image from "next/image";
import { ArrowRightIcon, DocumentIcon } from "@heroicons/react/24/solid";
import Link from "next/link";

const ManagementDesignSheetPage = () => {
  const META_TITLE = "経営デザインシート";
  const breadcrumbs = [
    {
      title: META_TITLE,
    },
  ];

  const sections = [
    {
      image: "management_design_sheet_section_1.png",
      title: "質問に答える",
      description:
        "中小企業のことを徹底的に考えた質問を複数用意致しました。会社の状況と向き合いながら質問に答えてみてください。",
    },
    {
      image: "management_design_sheet_section_2.png",
      title: "プレビューを確認",
      description: "~~~",
    },
    {
      image: "management_design_sheet_section_1.png",
      title: "専門家に質問",
      description:
        "中小企業のことを徹底的に考えた質問を複数用意致しました。会社の状況と向き合いながら質問に答えてみてください。",
    },
  ];

  return (
    <>
      <Head title={META_TITLE} canonicalPath={`/plans`} />
      <main className={"pb-20"}>
        <div className={"bg-blue-700 text-center leading-0"}>
          <div className={"hidden md:block"}>
            <Image
              src={"/images/index/management_design_sheet_kv.png"}
              width={1280}
              height={441}
              className={"m-auto"}
              alt={""}
            />
          </div>
          <div className={"md:hidden"}>
            <Image
              src={"/images/index/management_design_sheet_kv.sp.png"}
              width={375}
              height={350}
              alt={""}
            />
          </div>
        </div>
        <section className={"max-w-[1160px] mx-auto mt-10 mb-20 px-4"}>
          <div className={"flex"}>
            <h2
              className={
                "flex items-center py-2 px-4 text-lg bg-blue-700 text-white font-bold mb-4"
              }
            >
              <DocumentIcon className={"w-5 mr-2"} />
              事業計画を簡単作成
            </h2>
          </div>
          <div className={"grid grid-cols-3 gap-x-4"}>
            {sections.map((section, index) => (
              <div key={index} className={""}>
                <div className={"mb-3"}>
                  <Image
                    src={`/images/index/${section.image}`}
                    width={336}
                    height={260}
                    alt={""}
                  />
                </div>
                <div className={""}>
                  <h2 className={"text-lg mb-1 font-bold"}>
                    {index + 1}. {section.title}
                  </h2>
                  <p className={""}>{section.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
        <section className={"bg-gray-100 text-center py-20"}>
          <h2 className={"font-bold text-2xl mb-6"}>
            事業計画の困ったを解決します
          </h2>
          <Link
            href="/registrations/new"
            className={
              "flex items-center justify-center font-bold pl-2 text-sm md:text-base max-w-[500px] min-h-[56px] m-auto bg-white shadow rounded hover:text-blue-700 hover:border-b hover:border-blue-700 border-b border-b-white"
            }
          >
            まずは無料でお試し
            <ArrowRightIcon className={"w-5 ml-4"} />
          </Link>
        </section>
        <div className={"max-w-[1440px] m-auto px-4 py-2"}>
          <Breadcrumb breadcrumbs={breadcrumbs} />
        </div>
      </main>
    </>
  );
};

export async function getStaticProps() {
  return {
    props: {},
  };
}
export default ManagementDesignSheetPage;
